import { FC } from 'react';
import PaymentsCard from 'components/PaymentsCard';
import { HorizontalRule } from 'components/Layout';
import { Text } from '@qga/roo-ui/components';
import TotalLineItem from './TotalLineItem';
import PayableAtProperty from './PayableAtProperty';
import useDetailsBooking from 'hooks/useDetailsBooking';
import { useChangeDates } from 'pages/ChangeDatesPage/ChangeDatesProvider';

const PaymentTotals: FC = () => {
  const { booking } = useDetailsBooking();
  const { amendment } = useChangeDates();

  const type = amendment!.amendmentTotal!.type;

  if (type === 'NO_PAYMENT') {
    return (
      <PaymentsCard px={5} pb={5} mb={0}>
        <Text color="greys.steel" fontSize="lg">
          No additional payment is required for your date change.
        </Text>
        {amendment?.payableAtProperty?.total && (
          <>
            <HorizontalRule my={4} />
            <PayableAtProperty total={amendment?.payableAtProperty?.total} />
          </>
        )}
      </PaymentsCard>
    );
  }

  return (
    <PaymentsCard mb={0} px={5} pb={5}>
      <TotalLineItem mb={4} title="Total paid to date" totals={booking.paidBeforeCancellation.totals} />
      <TotalLineItem title="New booking total" totals={amendment!.amendmentTotal!.totals} />
      <HorizontalRule my={4} />
      {type === 'REFUND_PAYMENT' && <TotalLineItem strong title="Total refund" totals={amendment!.amendmentTotal!.adjustment} />}
      {type === 'ADDITIONAL_PAYMENT' && <TotalLineItem strong title="Total payment" totals={amendment!.amendmentTotal!.adjustment} />}
      {amendment?.payableAtProperty?.total && <PayableAtProperty mt={4} total={amendment?.payableAtProperty?.total} />}
    </PaymentsCard>
  );
};

export default PaymentTotals;
